import { useEffect, useState } from "react";
import { fetchPostingsPage } from "../api/postings";

export default function usePostings({
  market,
  state,
  page,
  pageSize,
  reloadToken,
}) {
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let cancel = false;

    (async () => {
      setLoading(true);
      try {
        const { rows: dataRows, total: count } = await fetchPostingsPage({
          market,
          state,
          page: page + 1,
          pageSize,
        });

        if (cancel) return;

        setRows(dataRows);
        setTotal(count);
      } catch (err) {
        console.error("Ошибка загрузки постингов:", err);
      } finally {
        if (!cancel) setLoading(false);
      }
    })();

    return () => {
      cancel = true;
    };
  }, [market, state, page, pageSize, reloadToken]);

  return { rows, total, loading };
}
